import { toDealBadgeSegmentProps } from '@/helpers/deals/dealBadgeSegmentProps'
import type { DealBadgeSegmentProps } from '@/helpers/deals/dealBadgeSegmentProps'
import { resolveDealBadge } from '@/helpers/deals/resolveDealBadge'
import { toBidderCountSegmentProps } from '@/helpers/listing/bidderCount'
import type { BidderCountSegmentProps } from '@/helpers/listing/bidderCount'
import { ScreenName } from '@/helpers/telemetry/ScreenName'
import { useDealBadgeFlags } from '@/hooks/useDealBadgeFlags'
import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

/**
 * GLOB-5164 — the deal-badge and bidder-count Segment properties for a List
 * view `view_details` click. One hook so every List-view click path reports
 * the same values.
 */
export const useListViewDealBadgeProps = (
  listing: CombinedListingSearchResult
): DealBadgeSegmentProps & BidderCountSegmentProps => {
  const flags = useDealBadgeFlags()
  const searchResult = listing.originalSearchResult

  return {
    ...toDealBadgeSegmentProps(
      resolveDealBadge(
        searchResult,
        // Either search-results screen works: both compute eligibility, and
        // `rendered: false` discards the screen-specific display decision.
        ScreenName.AllAuction,
        flags
      ),
      { rendered: false }
    ),
    ...toBidderCountSegmentProps(searchResult),
  }
}
